import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";
import './Button.css';

import IconTap from '../svg/IconTap';

import { toggleLayoutTablet } from "../../../actions/index";

function ConnectedButtonTap({ visible, active, style }) {
  const dispatch = useDispatch();

  const onClick = () => {
    (window.compact_toggle && window.compact_mode_enable) && window.compact_toggle();
    dispatch(toggleLayoutTablet())
  }

  return visible ? (
    <div className={`topbutton ${active && `active`} button-tap`} style={style} onClick={onClick}>
      <IconTap size={22} color={active ? Config.BRAND_PRIMARY : `#989898`} />
    </div>
  ) : null
}

ConnectedButtonTap.propTypes = {
  visible: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  style: PropTypes.object
}

const ButtonTap = connect(
  state => ({
    visible: (state.isConnected && state.isSubscribed),
    active: state.layoutTablet
  })
)(ConnectedButtonTap);

export default ButtonTap;
